__turbopack_context__.v({
  "iframe": "ThankYouEmbed-module__IopF4W__iframe",
  "wrapper": "ThankYouEmbed-module__IopF4W__wrapper",
});
